import script from "./Query.vue?vue&type=script&lang=ts&setup=true"
export * from "./Query.vue?vue&type=script&lang=ts&setup=true"

import "./Query.vue?vue&type=style&index=0&id=eb466cd4&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/certificate/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb466cd4"]])

export default __exports__